<template>
  <div>
    <apexchart type="pie" :options="options" :series="series" :width="largura"></apexchart>
    {{preencherGrafico}}
  </div>
</template>
<script>
/* eslint-disable */
import VueApexCharts from "vue-apexcharts";
import Dexie from "dexie";
import BibliotecaDeCalculos from "bibliotecadecalculos-f02";
import DadosDespesasAnimais from "../../class/DadosDespesasAnimal.js";
import DadosDasDespesas from "../../class/DadosDasDespesas.js";
import DadosDespesasManutencao from "../../class/DadosDespesasManutencao.js";
import DadosDespesasServicos from "../../class/DadosDespesasServicos.js";
import DadosDasReceitas from "../../class/DadosDasReceitas.js";
import DadosRecursosAnimais from "../../class/DadosRecursosAnimais.js";
import DadosRecursosInstalacoes from "../../class/DadosRecursosInstalacoes.js";
import DadosRecursosMaquinas from "../../class/DadosRecursosMaquinas.js";
import DadosRecursosPastagensOutros from "../../class/DadosRecursosPastagensOutros.js";
import ReceitaAnual from "../../class/ReceitaAnual.js";
import ReceitaAnualAbate from "../../class/ReceitaAnualAbate.js";
import RebanhoDeRecria from "../../class/RebanhoDeRecria.js";

import OutrasReceitas from "../../class/OutrasReceitas.js";
import RebanhoDeReproducao from "../../class/RebanhoDeReproducao.js";

export default {
  components: {
    apexchart: VueApexCharts
  },
  data: () => ({
    options: {
      legend: {
        position: "top"
      },
      colors: [
        "#BF343F",
        "#A7E4F2",
        "#32736C",
        "#D9B504",
        "#F2811D",
        "#BFBFBF",
        "#A63C76",
        "#128BA6",
        "#BF343F",
        "#A7E4F2"
      ],
      labels: [
        "Depreciações",
        "Juros",
        "Pró-labore",
        "Manutenção e arrendam. pastagens",
        "Manut. Instal., máq. e equipam.",
        "Compra animais p/ recria/engorda",
        "Despesas diretas com animais",
        "Combustíveis e lubrif.",
        "Mão de obra",
        "Serviços técnicos, impostos e taxas, despesas administ. e outras"

      ],
       dataLabels: {
        enabled: true,
        formatter: function(val, opts) {
          return (parseFloat(opts.w.config.series[opts.seriesIndex].toFixed(2))).toLocaleString("pt-BR", {style: 'currency', currency: 'BRL'});
        }
      },
      tooltip: {
        y: {
          formatter: function(val) {
            var valor = val
            if(typeof valor !== "undefined")
            {
              return (parseFloat(valor.toFixed(2))).toLocaleString("pt-BR", {style: 'currency', currency: 'BRL'});
            }else 
              return valor
          } 
        }
      }
    },
    series: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    largura: "100%",
    comprimento: "200%",
    formulario: "",
    simulation: ''
  }),

 mounted() {
    var self = this;
    this.$db.simulation.get(this.$route.params.code, function(s) {
      self.simulation = s;
    });
  },
  computed:{
    preencherGrafico: function() {
      this.$db.simulation.get({ code: this.simulation.code }, dado => {
        var manutencao = new DadosDespesasManutencao(dado.dadosManutencao);
        var despesas = new DadosDasDespesas(dado.dadosDasDespesas);
        var servicos = new DadosDespesasServicos(dado.dadosDespesasServicos);
        var animais = new DadosDespesasAnimais(dado.dadosDespesasAnimal);
        var receitas = new DadosDasReceitas(dado.proLabore);
        var pastagens = new DadosRecursosPastagensOutros(dado.dadosRecursosPastagensOutros);
        var instalacoes = new DadosRecursosInstalacoes(dado.dadosRecursosInstalacoes);
        var maquinas = new DadosRecursosMaquinas(dado.dadosRecursosMaquinas);
        var animaisRecursos = new DadosRecursosAnimais(dado.dadosRecursosAnimais);
        var rebanhoReproducao = new RebanhoDeReproducao(dado.rebanhoReproducao);
        var abate = new ReceitaAnualAbate(dado.bovinoAbate);
        var outro = new ReceitaAnual(dado.bovinoOutro);
        var recria = new RebanhoDeRecria(dado.rebanhoRecria);
        var outrasReceitas = new OutrasReceitas(dado.outrasReceitas);

        var biblioteca = [   
            BibliotecaDeCalculos.CalculosDosGraficos(BibliotecaDeCalculos.RecursosPastagens(pastagens), 
            BibliotecaDeCalculos.RecursosInstalacoes(instalacoes), 
            BibliotecaDeCalculos.RecursosMaquinas(maquinas), BibliotecaDeCalculos.RecursosAnimais(animaisRecursos), 
            BibliotecaDeCalculos.RebanhoDeReproducao(rebanhoReproducao), BibliotecaDeCalculos.DespesasAnimais(animais), 
            BibliotecaDeCalculos.Despesas(despesas), 
            BibliotecaDeCalculos.DadosDasReceitas(receitas), BibliotecaDeCalculos.DespesasManutencao(manutencao, BibliotecaDeCalculos.RecursosInstalacoes(instalacoes), BibliotecaDeCalculos.RecursosMaquinas(maquinas)), 
            BibliotecaDeCalculos.DespesasServicos(servicos), BibliotecaDeCalculos.RebanhoDeVenda(abate, outro), 
            BibliotecaDeCalculos.RebanhoDeRecria(recria), BibliotecaDeCalculos.OutrasReceitas(outrasReceitas)), 
            BibliotecaDeCalculos.DadosDasReceitas(receitas), 
            BibliotecaDeCalculos.DespesasManutencao(manutencao, BibliotecaDeCalculos.RecursosInstalacoes(instalacoes), BibliotecaDeCalculos.RecursosMaquinas(maquinas)), 
            BibliotecaDeCalculos.DespesasAnimais(animais), 
            BibliotecaDeCalculos.DespesasServicos(servicos)
        
        ];
        
        return biblioteca;
      })
      .then(
        g => (
          (this.series[0] = g[0].totalDepreciacoes()),
          (this.series[1] = g[0].jurosTotais()),
          (this.series[2] = g[1].totalRetirada()),
          (this.series[3] = g[2].despesasPastagens()),
          (this.series[4] = g[2].despesasMaquinasEquipamentos() + g[2].despesasInstalacoesBenfeitorias()),
          (this.series[5] = g[3].despesasAnimaisRecriaEngorda()),
          (this.series[6] = (g[3].despesasAnimaisRecriaEngorda() + g[3].despesasInseminacaoArtificalReproducao() + g[3].despesasProdutosVeterinarios() + g[3].despesasSuplementacao())),
          (this.series[7] = g[4].despesasCombustiveisLubrificantes()),
          (this.series[8] = g[4].despesasMaoDeObra()),
          (this.series[9] = (g[4].despesasServicosTecnicos() + g[4].despesasImpostosTaxas() + g[4].despesasAdministrativas() + g[4].despesasOutrasDespesas()))

        )
      );
    }
  }
};
</script>
<style scoped>
</style>
